module.exports = __webpack_public_path__ + "img/76034.ac89a102.svg";